const enums = {
    entityType: ['Facility', 'System_Facility', 'Business_Group', 'Account', 'System_Account', 'System_Business_Group'],
    configType: ['Normal_Config', 'System_Config'],
    deactivateType: ['Hard_Deactivate', 'Deactivate_For_Future', 'Not_Allowed'],
    configurationTab: ['Facility', 'Billing_And_Allocation', 'Payments', 'Occupancy', 'Units', 'Tenants', 'Documentation', 'Third_Party_Support'],
};

export default enums;
